import { i18nMark } from 'lingui-react';

const formattedMessages = {
  campaignStatusGreen: i18nMark('current'),
  campaignStatusRed: i18nMark('campaign due'),
  noValue: i18nMark('Not Provided'),
  pmStatusGreen: i18nMark('current'),
  pmStatusYellow: i18nMark('due'),
  pmStatusRed: i18nMark('overdue'),
  undefinedComplaint: i18nMark('No complaints yet'),
  undefinedComplaintCode: i18nMark('Code Not Provided'),
  undefinedComplaintDescription: i18nMark('Description Not Provided'),
  warrantyStatusGreen: i18nMark('fully covered'),
  warrantyStatusYellow: i18nMark('partially covered'),
  warrantyStatusRed: i18nMark('expired'),
  warrantyStatusGrey: i18nMark('no coverage'),
  searchResults: i18nMark('Search Results'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./utils/messages.js